import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExtraFieldModel } from '../../../models/extra-field.model';
import { FormGroup } from '@angular/forms';
import { ValidationManager } from 'ng2-validation-manager';

@Component({
    'selector': 'extra-fields-list-item',
    'templateUrl': './extra-fields-list.item.component.html'
})
export class ExtraFieldsListItemComponent {
    @Input() extraField: ExtraFieldModel;
    @Input() extraFieldsForm: FormGroup;
    @Input() validation: ValidationManager;
    @Output() extraFieldChanged: EventEmitter<string> = new EventEmitter<string>();

    /**
     * Emit event when the field is changed
     * */
    onFieldChange(slug: string) {
        this.extraFieldChanged.emit(slug);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/components/extra-fields-list/item/extra-fields-list.item.component.ts